import React from 'react';
import { UIContent } from './UIContent';
import { UIActions } from './UIActions';
import { UIPlaying } from './UIPlaying';
import { UIPaused } from './UIPaused';

export const TrustyUI = ({ mode }) => {
    if (mode === "content") return <UIContent />;
    if (mode === "actions") return <UIActions />;
    if (mode === "playing") return <UIPlaying />;
    if (mode === "paused") return <UIPaused />;
    return null;
};
